import { render, staticRenderFns } from "./InputSecondsAsTime.vue?vue&type=template&id=596d7386"
import script from "./InputSecondsAsTime.vue?vue&type=script&lang=js"
export * from "./InputSecondsAsTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports